import { useEffect, useState } from 'react'
import { AUTH_ROLE_MISMATCH_KEY } from '@/shared/lib/storageKeys'

export function markAuthRoleMismatch() {
  sessionStorage.setItem(AUTH_ROLE_MISMATCH_KEY, '1')
}

export function useAuthMismatchNotice() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (sessionStorage.getItem(AUTH_ROLE_MISMATCH_KEY) !== '1') return
    sessionStorage.removeItem(AUTH_ROLE_MISMATCH_KEY)
    setShow(true)

    const timer = setTimeout(() => setShow(false), 5000)
    return () => clearTimeout(timer)
  }, [])

  return show
}
